// src/data/muscleGroups.js
export const muscleGroups = [
    { id: "trapezius", name: "Trapezius" },
    { id: "deltoids", name: "Deltoids" },
    { id: "rear_deltoids", name: "Rear Deltoids" },
    { id: "chest", name: "Chest" },
    { id: "upper_back", name: "Upper Back" },
    { id: "back", name: "Back" },
    { id: "lower_back", name: "Lower Back" },
    { id: "biceps", name: "Biceps" },
    { id: "triceps", name: "Triceps" },
    { id: "forearms", name: "Forearms" },
    { id: "abs", name: "Abs" },
    { id: "obliques", name: "Obliques" },
    { id: "hip_flexors", name: "Hip Flexors" },
    { id: "glutes", name: "Glutes" },
    { id: "legs", name: "Legs" },
    { id: "quadriceps", name: "Quadriceps" },
    { id: "hamstrings", name: "Hamstrings" },
    { id: "calves", name: "Calves" },
];
